import { Component, OnInit } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";

@Component({
  selector: "app-root",
  template: `
  <router-outlet></router-outlet>
  `
})
export class AppComponent {
  title = "app";

  constructor(
    private router: Router,
  ) {

  }
  ngOnInit(): void {
    this.router.navigate(['/home']);
  }
}
